// src/components/TileBuilder/ChartControls/ChartAggregationControls.tsx
import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { setSettings } from '../../../../support/slices/tileBuilderSlice';
import { ChartControlProps } from './ChartControlProps';

const AGG_OPTIONS = [
  { value: 'auto', label: 'Auto (based on Value Field)' },
  { value: 'count', label: 'Count' },
  { value: 'sum', label: 'Sum' },
  { value: 'avg', label: 'Average' },
  { value: 'min', label: 'Min' },
  { value: 'max', label: 'Max' },
];

const ChartAggregationControls: React.FC<ChartControlProps> = ({ chartId, settings, dispatch, derivedFields }) => {
  const fields = derivedFields ?? [];

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
      <Typography variant="subtitle2" sx={{ width: '100%' }}>
        Aggregation (raw rows → chart series)
      </Typography>

      <FormControl sx={{ minWidth: 220 }}>
        <InputLabel>Series Field</InputLabel>
        <Select
          label="Series Field"
          value={(settings as any).seriesField ?? ''}
          onChange={(e) =>
            dispatch(setSettings({ chartId, settings: { seriesField: e.target.value as string } }))
          }
        >
          <MenuItem value="">(None — single series)</MenuItem>
          {fields.map((f) => (
            <MenuItem key={f} value={f}>
              {f}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ minWidth: 220 }}>
        <InputLabel>Aggregate</InputLabel>
        <Select
          label="Aggregate"
          value={(settings as any).aggregate ?? 'auto'}
          onChange={(e) =>
            dispatch(setSettings({ chartId, settings: { aggregate: e.target.value as any } }))
          }
        >
          {AGG_OPTIONS.map((o) => (
            <MenuItem key={o.value} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ChartAggregationControls;